

import React from 'react';
import './loadere.scss'

function Loadere() {
   return (
      <div className='loader-cona'>
         <div className='loader'>
            <span className='loader-item item-1'></span>
            <span className='loader-item item-2'></span>
            <span className='loader-item item-3'></span>
         </div>  
      </div>
   );
}

export default Loadere